var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "form-row", attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "库存节点名称" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.nodeName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "nodeName", $$v)
                                },
                                expression: "queryCondition.nodeName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "库存节点组" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "handle-input",
                                model: {
                                  value: _vm.queryCondition.nodeGroup,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "nodeGroup",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.nodeGroup",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: "1",
                                  attrs: { label: "外库", value: "外库" },
                                }),
                                _c("el-option", {
                                  key: "2",
                                  attrs: { label: "成品库", value: "成品库" },
                                }),
                                _c("el-option", {
                                  key: "3",
                                  attrs: { label: "工厂库", value: "工厂库" },
                                }),
                                _c("el-option", {
                                  key: "4",
                                  attrs: { label: "供应商", value: "供应商" },
                                }),
                                _c("el-option", {
                                  key: "6",
                                  attrs: { label: "客户", value: "客户" },
                                }),
                                _c("el-option", {
                                  key: "7",
                                  attrs: { label: "制造", value: "制造" },
                                }),
                                _c("el-option", {
                                  key: "8",
                                  attrs: { label: "维修", value: "维修" },
                                }),
                                _c("el-option", {
                                  key: "9",
                                  attrs: { label: "售后", value: "售后" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "query-btn-row" },
                  [
                    _c(
                      "el-col",
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v("搜索"),
                        ]),
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v("重置"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "form-row", attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "库存节点编号" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.nodeNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "nodeNo", $$v)
                                },
                                expression: "queryCondition.nodeNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否有效" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "handle-input",
                                model: {
                                  value: _vm.queryCondition.isEffective,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "isEffective",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.isEffective",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: "1",
                                  attrs: { label: "是", value: "是" },
                                }),
                                _c("el-option", {
                                  key: "0",
                                  attrs: { label: "否", value: "否" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.addOrEditMaterial },
              },
              [_vm._v("新增")]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.downloadTemplate },
              },
              [_vm._v("下载")]
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            staticClass: "table",
            attrs: {
              data: _vm.tableData,
              border: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "name", label: "库存节点名称" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "router-link",
                        {
                          staticClass: "a-link",
                          attrs: {
                            replace: "",
                            to: {
                              name: "inventory-node-edit",
                              params: { nodeName: scope.row.nodeName },
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.nodeName))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "nodeNo", label: "库存节点编号" },
            }),
            _c("el-table-column", {
              attrs: { prop: "nodeGroup", label: "库存节点组" },
            }),
            _c("el-table-column", {
              attrs: { prop: "updateTime", label: "更新日期" },
            }),
            _c("el-table-column", {
              attrs: { prop: "updateUser", label: "更新人" },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: { layout: "prev, pager, next", total: _vm.total },
              on: { "current-change": _vm.handleCurrentChange },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }